// eslint-disable-next-line import/no-cycle
import rootSaga from './rootSaga';

export default rootSaga;
